(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/scroll-to-hash/assets/scroll-to-hash.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/scroll-to-hash/assets/scroll-to-hash.js');

'use strict';

const ScrollToHash = _ref => {
  let hash = _ref.hash,
    _ref$isReady = _ref.isReady,
    isReady = _ref$isReady === void 0 ? true : _ref$isReady,
    _ref$useLocationHook = _ref.useLocationHook,
    useLocationHook = _ref$useLocationHook === void 0 ? ReactRouterDOM.useLocation : _ref$useLocationHook,
    _ref$useEffectHook = _ref.useEffectHook,
    useEffectHook = _ref$useEffectHook === void 0 ? React.useEffect : _ref$useEffectHook;
  const location = useLocationHook();
  const HASH_ID_PREFIX = 'scroll-to-hash-';
  const SCROLL_MARGIN_TOP = 24;
  const FIXED_TOP_CONTENT_HEIGHT_FALLBACK = 112;
  useEffectHook(() => {
    const scrollToHash = () => {
      if (location.hash === "#".concat(hash)) {
        const id = "".concat(HASH_ID_PREFIX).concat(location.hash.replace('#', ''));
        const el = document.getElementById(id);
        if (el) {
          const fixedTopContent = document.querySelector('.js-fixed-top-content');
          const topContent = document.querySelector('#top-content');
          const fixedTopContentHeight = fixedTopContent ? fixedTopContent.offsetHeight : 0;
          const topContentHeight = topContent ? topContent.offsetHeight : 0;
          el.style.scrollMarginTop = "".concat((fixedTopContentHeight || topContentHeight || FIXED_TOP_CONTENT_HEIGHT_FALLBACK) + SCROLL_MARGIN_TOP, "px");
          el.scrollIntoView({
            behavior: 'smooth'
          });
          return true;
        }
        return false;
      }
      return true;
    };
    if (!isReady) {
      return;
    }
    if (scrollToHash()) {
      return;
    }
    const observer = new MutationObserver(() => {
      if (scrollToHash()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => observer.disconnect();
  }, [location, isReady]);
  return React.createElement("a", {
    "data-testid": "".concat(HASH_ID_PREFIX).concat(hash),
    id: "".concat(HASH_ID_PREFIX).concat(hash)
  });
};
svs.tb_ui_react.scroll_to_hash.ScrollToHash = ScrollToHash;

 })(window);